export default __webpack_public_path__ + "static/bg-cycle-2-08afb3f137666267ceeb060f8c308763.png";